module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-container"
  }, [_c('div', {
    staticClass: "basic-info"
  }, [_c('div', [_c('div', {
    staticClass: "head"
  }, [(_vm.articleInfo.is_top) ? _c('img', {
    staticClass: "top",
    attrs: {
      "src": require("../../images/community/top.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleInfo.afterHtmlTitle) ? _c('h3', {
    staticClass: "question-name",
    on: {
      "click": function($event) {
        return _vm.goArticleDetail(_vm.articleInfo)
      }
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.filterXSS(_vm.articleInfo.afterHtmlTitle))
    }
  })]) : _c('h3', {
    staticClass: "question-name",
    on: {
      "click": function($event) {
        return _vm.goArticleDetail(_vm.articleInfo)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.articleInfo.title) + "\n                ")])]), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, _vm._l((_vm.articleInfo.tags), function(i, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.tagSelector(i)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(i.title) + "\n                ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "question-desc",
    on: {
      "click": function($event) {
        return _vm.goArticleDetail(_vm.articleInfo)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleInfo.descText)
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "descHook",
    staticClass: "question-desc img-hook",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": ("virtual-dom-" + (_vm.articleInfo.id))
    },
    domProps: {
      "innerHTML": _vm._s(_vm.filterXSS(_vm.articleInfo.afterhtmlData))
    }
  }), _vm._v(" "), (_vm.articleInfo.imgSrc !== '') ? _c('p', {
    staticClass: "question-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.articleInfo.imgSrc
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "comment-bottom-content"
  }, [_c('div', {
    staticClass: "footer-list"
  }, [(_vm.isSearch) ? _c('div', {
    staticClass: "answer-type"
  }, [_vm._v("文章")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "footer-item default"
  }, [_c('i', {
    staticClass: "smart-icon view-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("transformUnit")(_vm.articleInfo.no_of_views))), _c('i', {
    staticClass: "text"
  }, [_vm._v("阅读")])])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.articleInfo.is_vote_up ? '取消点赞' : '点赞',
      "placement": "top"
    }
  }, [_c('p', {
    class: ['footer-item', 'great', {
      'is-active': _vm.articleInfo.is_vote_up
    }],
    on: {
      "click": function($event) {
        return _vm.onVoteToggle(_vm.articleInfo)
      }
    }
  }, [_c('i', {
    staticClass: "smart-icon like-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.articleInfo.no_of_vote_up)), _c('i', {
    staticClass: "text"
  }, [_vm._v("赞")])])])]), _vm._v(" "), _c('p', {
    class: ['footer-item', 'comment', {
      'is-active': _vm.articleInfo.is_me_comment
    }],
    on: {
      "click": function($event) {
        return _vm.goArticleDetail(_vm.articleInfo, true)
      }
    }
  }, [_c('i', {
    staticClass: "smart-icon comment-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.articleInfo.no_of_comment)), _c('i', {
    staticClass: "text"
  }, [_vm._v("评论")])])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.articleInfo.is_liked ? '取消收藏' : '收藏',
      "placement": "top"
    }
  }, [_c('p', {
    class: ['footer-item', 'favorite', {
      'is-active': _vm.articleInfo.is_liked
    }],
    on: {
      "click": function($event) {
        return _vm.favoriteToggle(_vm.articleInfo)
      }
    }
  }, [_c('i', {
    staticClass: "smart-icon collect-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.articleInfo.no_of_likes)), _c('i', {
    staticClass: "text"
  }, [_vm._v("收藏")])])])])], 1), _vm._v(" "), _c('p', {
    staticClass: "topic-people"
  }, [_c('el-popover', {
    attrs: {
      "popper-class": "user-card",
      "placement": "top",
      "open-delay": 500,
      "width": "400",
      "trigger": "hover"
    },
    on: {
      "show": function($event) {
        _vm.$refs['card' + _vm.articleInfo.created_by.id].getUserInfo()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0, padding: 0"
    }
  }, [_c('user-card', {
    ref: ("card" + (_vm.articleInfo.created_by.id)),
    attrs: {
      "user-id": _vm.articleInfo.created_by.id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-avatar",
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    },
    slot: "reference"
  }, [(_vm.articleInfo.created_by.user_logo.substr(0, 1) == '?') ? _c('img', {
    staticClass: "create-user-logo",
    attrs: {
      "src": require("../../images/personal_center/avatar_default.png")
    },
    on: {
      "click": function($event) {
        return _vm.goHomePage(_vm.articleInfo.created_by)
      }
    }
  }) : _c('img', {
    staticClass: "create-user-logo",
    attrs: {
      "src": _vm.articleInfo.created_by.user_logo,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.goHomePage(_vm.articleInfo.created_by)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "create-user-name",
    domProps: {
      "innerHTML": _vm._s(_vm.articleInfo.afterHtmlName)
    },
    on: {
      "click": function($event) {
        return _vm.goHomePage(_vm.articleInfo.created_by)
      }
    }
  })])]), _vm._v(" "), (_vm.articleInfo.created_by.is_official) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "蓝鲸智云官方",
      "placement": "right"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-lanjingguanfang"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.articleInfo.created_by.is_vip) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "核心用户",
      "placement": "right"
    }
  }, [_c('span', {
    staticClass: "icon-vipuser"
  })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" 于 " + _vm._s(_vm.articleInfo.created_on))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7821310d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/articleContainer.vue
// module id = n3cD
// module chunks = 16